import { Injectable, InjectionToken, inject } from '@angular/core';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../../../environments/environment';
export const OKTA_AUTH_CLIENT = new InjectionToken<any>('OKTA_AUTH_CLIENT');

@Injectable({
  providedIn: 'root'
})
export class OktaService {
  private oktaAuthClient = inject<OktaAuth>(OKTA_AUTH_CLIENT);

  isUserLoggedIn(): Promise<boolean> {
    return this.oktaAuthClient.session.exists();
  }

  signIn(credentials: any) {
    return this.oktaAuthClient.signIn(credentials);
  }

  setCookieAndRedirect(sessionToken: string, redirectUrl?: string) {
    if (redirectUrl) {
      return this.oktaAuthClient.session.setCookieAndRedirect(sessionToken, redirectUrl);
    }
    return this.oktaAuthClient.session.setCookieAndRedirect(sessionToken);
  }

  sessionExists() {
    return this.oktaAuthClient.session.exists();
  }

  getTokens(scopes: string[]) {
    return this.oktaAuthClient.token.getWithoutPrompt({ scopes });
  }

  async logout(postLogoutRedirectUri?: string): Promise<void> {
    if (environment.useNewLoginPage) {
      try {
        await this.oktaAuthClient.stop();
      } catch (e) {
        console.error('stop: ', e);
      }
      try {
        await this.oktaAuthClient.signOut({
          revokeAccessToken: true,
          revokeRefreshToken: true,
          clearTokensBeforeRedirect: true,
          postLogoutRedirectUri: postLogoutRedirectUri
        });
      } catch (e) {
        console.error('signOut: ', e);
      }
    } else {
      if (await this.isUserLoggedIn()) {
        await this.oktaAuthClient.revokeAccessToken();
        await this.oktaAuthClient.closeSession();
      }
    }
  }
}

